import styled from 'styled-components'

import { style } from 'theme'

export const CTAContainer = styled.div`
  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    background-color: ${style(theme => theme.colors.white)};
    bottom: 0;
    left: 0;
    padding: 10px 20px 20px 20px;
    position: fixed;
    width: 100%;
  }
`
